export function calculateExcVatPrice(
	priceIncVat: number | string | null | undefined,
	vatRate: number | null | undefined,
): number | undefined {
	if (typeof priceIncVat !== 'number' || typeof vatRate !== 'number') {
		return undefined;
	}

	return Math.round((priceIncVat / (1 + vatRate / 100)) * 100) / 100;
}
